// eventually remove clear from scal and remove translucent in ncal
export const colorSchemes = {
  SCAL: {
    gunmetal: { group: 'Neutral/Metallic', color: 'bg-[#818589]' },
    translucent: { group: 'Neutral/Metallic', color: 'bg-[#F5F5F5]' },
    bronze: { group: 'Neutral/Metallic', color: 'bg-[#DAA520]' },
    gold: { group: 'Neutral/Metallic', color: 'bg-[#FFD700]' },
    grey: { group: 'Neutral/Metallic', color: 'bg-[#808080]' },
    rosegold: { group: 'Neutral/Metallic', color: 'bg-[#BC8F8F]' },
    silver: { group: 'Neutral/Metallic', color: 'bg-[#C0C0C0]' },
    white: { group: 'Neutral/Metallic', color: 'bg-[#FFFFFF]' },
    red: { group: 'Colors', color: 'bg-[#FF0000]' },
    purple: { group: 'Colors', color: 'bg-[#800080]' },
    blue: { group: 'Colors', color: 'bg-[#0000FF]' },
    green: { group: 'Colors', color: 'bg-[#008000]' },
    clear: { group: 'Neutral/Metallic', color: 'bg-[#FFFAFA]' },
    multipattern: {
      group: 'Colors',
      color:
        "bg-[url('https://images.contentstack.io/v3/assets/bltd38de548fe5a8d52/blt8b1d16f2c0fcd123/631250668bdc107d4a01d7f6/Multi_Pattern.jpg')]",
    },
    orange: { group: 'Colors', color: 'bg-[#FFA500]' },
    pink: { group: 'Colors', color: 'bg-[#FFC0CB]' },
    yellow: { group: 'Colors', color: 'bg-[#FFFF00]' },
    brown: { group: 'Brown/Tortoise', color: 'bg-[#8B4513]' },
    tortoise: {
      group: 'Brown/Tortoise',
      color:
        "bg-[url('https://images.contentstack.io/v3/assets/bltd38de548fe5a8d52/blt26e1d4d3e6668712/631250667066f57e88f6d219/Tortoise_Pattern.jpg')]",
    },
    black: { group: 'Black', color: 'bg-[#000000]' },
  },
  NCAL: {
    gunmetal: { group: 'Neutral/Metallic', color: 'bg-[#818589]' },
    translucent: { group: 'Neutral/Metallic', color: 'bg-[#F5F5F5]' },
    bronze: { group: 'Neutral/Metallic', color: 'bg-[#DAA520]' },
    gold: { group: 'Neutral/Metallic', color: 'bg-[#FFD700]' },
    grey: { group: 'Neutral/Metallic', color: 'bg-[#808080]' },
    rosegold: { group: 'Neutral/Metallic', color: 'bg-[#BC8F8F]' },
    silver: { group: 'Neutral/Metallic', color: 'bg-[#C0C0C0]' },
    white: { group: 'Neutral/Metallic', color: 'bg-[#FFFFFF]' },
    clear: { group: 'Neutral/Metallic', color: 'bg-[#FFFAFA]' },
    red: { group: 'Colors', color: 'bg-[#FF0000]' },
    purple: { group: 'Colors', color: 'bg-[#800080]' },
    blue: { group: 'Colors', color: 'bg-[#0000FF]' },
    green: { group: 'Colors', color: 'bg-[#008000]' },
    multipattern: {
      group: 'Colors',
      color:
        "bg-[url('https://images.contentstack.io/v3/assets/bltd38de548fe5a8d52/blt8b1d16f2c0fcd123/631250668bdc107d4a01d7f6/Multi_Pattern.jpg')]",
    },
    orange: { group: 'Colors', color: 'bg-[#FFA500]' },
    pink: { group: 'Colors', color: 'bg-[#FFC0CB]' },
    yellow: { group: 'Colors', color: 'bg-[#FFFF00]' },
    brown: { group: 'Brown/Tortoise', color: 'bg-[#8B4513]' },
    tortoise: {
      group: 'Brown/Tortoise',
      color:
        "bg-[url('https://images.contentstack.io/v3/assets/bltd38de548fe5a8d52/blt26e1d4d3e6668712/631250667066f57e88f6d219/Tortoise_Pattern.jpg')]",
    },
    black: { group: 'Black', color: 'bg-[#000000]' },
  },
};
